import React from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import MediaQuery from 'react-responsive';

import Button from '../Button';
import logo from '../../assets/images/logo_header.svg';
import mobileNav from '../../assets/images/mobile_nav.svg';
import closeNav from '../../assets/images/close_nav.svg';
import { MIN_WIDTH } from '../Layout/enums';
import UserInfo from './UserInfo';
import NotificationList from '../Notifications';
import Alert from '../AlertAttention';

import './index.css';

//    <Link to="/resources" styleName={styleName}>Resources</Link>
//    <Link to="/faq" styleName={styleName}>FAQ</Link>

const ResourceLinks = (styleName, authToken, accountNumber) => {
  const logout = (
    <Link to="/logout" styleName={styleName}>Log Out</Link>
  );
  const offers = (
    <a href="https://www.myipo.com/offers" styleName={styleName}>Offers</a>
  );

  return (
    <div styleName="linkContainer">
      <div styleName="linkBox">
        <Link to="/about" styleName={styleName}>About</Link>
      </div>
      { authToken ? (
        <div styleName="linkBox">
          <Link to="/faq" styleName={styleName}>FAQ</Link>
          <Link styleName={styleName} to={`/account/${accountNumber}/docs`} >Account Documents</Link>
          { logout }
        </div>
      ) : (
        <div styleName="linkBox">
          { offers }
          <Link to="/faq" styleName={styleName}>FAQ</Link>
        </div>
      )}
    </div>
  );
};

export const Desktop = ({
  authToken,
  firstName,
  accountValue,
  pathName,
  accountNumber,
  user,
}) => (
  <div>
    {authToken ? (
      <div styleName="resourceSection">
        <div styleName="resourceWidthRestriction">
          <div>
            {ResourceLinks('linksSmall', authToken, accountNumber)}
          </div>
        </div>
      </div>
      ) : null}
    <div styleName="mainHeader">
      <div styleName="headerWidthRestriction">
        <Link to="/">
          <img
            src={logo}
            alt="My IPO"
            styleName="logo"
          />
        </Link>
        {!authToken ? (
          <div styleName="signedOutLinks">
            {ResourceLinks('linksMedium', authToken, accountNumber)}
            <div styleName="authOptions">
              <Button
                style={{ width: 144, marginLeft: '30px', padding: '0' }}
                to={{ pathname: 'https://www.myipo.com/register' }}
                target="_blank"
              >Sign Up
              </Button>
              <Button style={{ width: 144, marginLeft: '30px', padding: '0' }} to="/login">Log In</Button>
            </div>
          </div>
        ) : (
          <div styleName="headerLinkSection">
            <div>
              {pathName.startsWith('/portfolio') ?
                <Link to="/portfolio" styleName="linksLargeActive">Summary</Link> :
                <Link to="/portfolio" styleName="linksLarge">Summary</Link>
              }
              {pathName.startsWith('/offers') ?
                <Link to="/offers" styleName="linksLargeActive">Offers</Link> :
                <Link to="/offers" styleName="linksLarge">Offers</Link>
              }
              {pathName.startsWith('/history') ?
                <Link to="/history" styleName="linksLargeActive">History</Link> :
                <Link to="/history" styleName="linksLarge">History</Link>
              }
            </div>
            <div styleName="userInfoContainer">
              { accountNumber.length === 0 && user === null ? null : <Alert />}
              <UserInfo
                firstName={firstName}
                accountValue={accountValue}
                accountNumber={accountNumber}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
);

export const Mobile = ({
  accountNumber,
  accountValue,
  authToken,
  firstName,
  pathName,
  user,
}) => (
  <div>
    <div styleName="mobileHeader">
      { accountNumber.length === 0 && user === null ? null : <Alert />}
      <Link to="/">
        <img
          styleName="logo"
          src={logo}
          alt="My IPO"
        />
      </Link>
      <input
        id="mobileNavBtn"
        type="image"
        src={mobileNav}
        alt="Mobile Navigator"
        styleName="mobileNavBtn"
        onClick={() => {
          document.getElementById('mobileNav').style.visibility = 'visible';
          document.getElementById('mobileNav').style.width = '300px';
        }}
      />
    </div>
    <div styleName="mobileMenu" id="mobileNav">
      <input
        id="mobileCloseBtn"
        type="image"
        styleName="mobileCloseBtn"
        onClick={() => {
          document.getElementById('mobileNav').style.width = 0;
          document.getElementById('mobileNav').style.visibility = 'hidden';
        }}
        src={closeNav}
        alt="Close Mobile Navigator"
      />
      {!authToken ? (
        <div>
          <Link to="/login" styleName="mobileLinks">Log In</Link>
          <Link
            to={{ pathname: 'https://www.myipo.com/register' }}
            target="_blank"
            styleName="mobileLinks"
          >Sign Up
          </Link>
        </div>
      ) : (
        <div style={{ paddingRight: '40px', paddingBottom: '10px' }}>
          <UserInfo
            firstName={firstName}
            accountValue={accountValue}
            accountNumber={accountNumber}
          />
        </div>
      )}
      <div styleName={`${!authToken ? 'centered-line' : 'mobileSep'}`} />
      {authToken ? (
        <div styleName="linkContainer">
          {pathName.startsWith('/portfolio') ?
            <Link to="/portfolio" styleName="mobileLinksActive">Summary</Link> :
            <Link to="/portfolio" styleName="mobileLinks">Summary</Link>
          }
          {pathName.startsWith('/offers') ?
            <Link to="/offers" styleName="mobileLinksActive">Offers</Link> :
            <Link to="/offers" styleName="mobileLinks">Offers</Link>
          }
          {pathName.startsWith('/history') ?
            <Link to="/history" styleName="mobileLinksActive">History</Link> :
            <Link to="/history" styleName="mobileLinks">History</Link>
          }
          {pathName.startsWith('/account') ?
            <Link to={`/account/${accountNumber}`} styleName="mobileLinksActive">Manage Account</Link> :
            <Link to={`/account/${accountNumber}`} styleName="mobileLinks">Manage Account</Link>

          }
        </div>
      ) : null}
      {authToken ? (<div styleName="mobileSep" />) : null}
      {ResourceLinks('mobileLinks', authToken, accountNumber)}
    </div>
  </div>
);


export const Header = ({
  authToken,
  firstName,
  accountValue,
  location,
  accountNumber,
  cashBalance,
  user,
}) => (
  <div styleName="headerMain">
    <NotificationList />
    <MediaQuery minWidth={MIN_WIDTH.DESK + 1}>
      <Desktop
        firstName={firstName}
        accountValue={accountValue + cashBalance}
        authToken={authToken}
        pathName={location.pathname}
        accountNumber={accountNumber}
        user={user}
      />
    </MediaQuery>
    <MediaQuery maxWidth={MIN_WIDTH.DESK}>
      <Mobile
        firstName={firstName}
        accountValue={accountValue + cashBalance}
        authToken={authToken}
        pathName={location.pathname}
        accountNumber={accountNumber}
        user={user}
      />
    </MediaQuery>
  </div>
);

Header.propTypes = {
  authToken: PropTypes.string,
  firstName: PropTypes.string,
  accountValue: PropTypes.number,
  accountNumber: PropTypes.string,
  cashBalance: PropTypes.number,
  user: PropTypes.shape({}),
};

Header.defaultProps = {
  authToken: null,
  firstName: 'Guest',
  accountValue: null,
  accountNumber: null,
  cashBalance: null,
  user: null,
};

const mapStateToProps = state => ({
  accountNumber: state.currentAccount,
  authToken: state.authToken,
  accountValue: get(state, 'accountValue.accountValue'),
  cashBalance: state.accountCashBalanceByAccount && state.currentAccount ?
    Number.parseFloat(get(state.accountCashBalanceByAccount[state.currentAccount], 'data.balanceBeforeCurrentActivity')) : 0,
  firstName: get(state, 'user.data.identity.firstName', 'Guest'),
  user: get(state, 'user.data'),
});

const enhance = compose(
  connect(mapStateToProps),
  withRouter,
);

const ConnectedHeader = enhance(Header);

export default ConnectedHeader;



// WEBPACK FOOTER //
// ./src/components/Header/index.js